"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MessagingSessionConfiguration]] contains the information necessary to start
 * a messaging session.
 */

/* eslint  @typescript-eslint/no-explicit-any: 0, @typescript-eslint/explicit-module-boundary-types: 0 */

var MessagingSessionConfiguration = /*#__PURE__*/function () {
  /**
   * Constructs a MessagingSessionConfiguration optionally with userArn, messaging session id, a messaging session
   * endpoint URL, the chimeClient, and the AWSClient.
   * The messaging session id is to uniquely identify this messaging session for the userArn.
   * If messaging session id is passed in as null, it will be automatically generated.
   */
  function MessagingSessionConfiguration(userArn, messagingSessionId, endpointUrl, chimeClient, awsClient) {
    _classCallCheck(this, MessagingSessionConfiguration);

    this.userArn = userArn;
    this.messagingSessionId = messagingSessionId;
    this.endpointUrl = endpointUrl;
    this.chimeClient = chimeClient;
    this.awsClient = awsClient;
    /**
     * Maximum amount of time in milliseconds to allow for reconnecting.
     */

    this.reconnectTimeoutMs = 10 * 1000;
    /**
     * Fixed wait amount in milliseconds between reconnecting attempts.
     */

    this.reconnectFixedWaitMs = 0;
    /**
     * The short back off time in milliseconds between reconnecting attempts.
     */

    this.reconnectShortBackoffMs = 1 * 1000;
    /**
     * The long back off time in milliseconds between reconnecting attempts.
     */

    this.reconnectLongBackoffMs = 5 * 1000;

    if (!this.messagingSessionId) {
      this.messagingSessionId = this.generateSessionId();
    }
  }

  _createClass(MessagingSessionConfiguration, [{
    key: "generateSessionId",
    value: function generateSessionId() {
      var num = new Uint32Array(1);
      var randomNum = window.crypto.getRandomValues(num);
      return randomNum[0].toString();
    }
  }]);

  return MessagingSessionConfiguration;
}();

exports.default = MessagingSessionConfiguration;